import {
  Button,
  Classes,
  Dialog,
  Tab,
  Tabs,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as moment from "moment";
import * as React from "react";
import { ResultadoStore } from "../../../../stores/resultados/ResultadoStore";
import { copyToClipboard } from "../../../../utils";
import { toast } from "react-toastify";
import { api } from "../../../../api";
import { AppStore } from "../../../../stores/AppStore";
import { ItemMemoria } from "./ItemMemoria";
import { MDBBtn } from "mdbreact";
const numeral = require("numeral");

interface CTEItemDialogProps {
  item: any;
  modelo: string;
  entrada_saida: string;
  onClose: () => void;
}

interface CTEItemDialogState { }

@observer
export class CTEItemDialog extends React.Component<
  CTEItemDialogProps,
  CTEItemDialogState
> {
  obs = observable({
    item: null as any,
    dhemi: null as string
  })

  async componentDidMount() {
    let data = {
      chave: this.props.item.chave,
      tipo: this.props.entrada_saida,
      item: this.props.item._id,
      modelo: this.props.modelo,
    };

    try {
      let resp = await api.post(`/api/notas/cte/item`, data);
      this.obs.dhemi = resp.data.dhemi;
      this.obs.item = resp.data;

      if (resp.data.calc_id) await ResultadoStore.loadDetalhamentoCalculo(resp.data.calc_id);

    } catch (ex) {
      toast.error("Erro ao visualizar Item CTE Contestação, tente novamente mais tarde.", {});
    }
  }

  renderNoData() {
    return (
      <div>
        Aguarde... &nbsp; &nbsp; &nbsp;
        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  handleViewXML = (chave: string, entrada_saida: string, modelo: string, dhemi: string) => {
    ResultadoStore.download_xml(chave, entrada_saida, modelo, dhemi, AppStore.obs1.selectedEmpresa?.cnpj);
  };

  handleCopyChave = () => {
    copyToClipboard(this.obs.item.chave);
    toast.success("Chave de acesso copiada", {});
  };

  handleCopyId = () => {
    copyToClipboard(this.obs.item?.contestacao_id);
    toast.success("Id Contestação copiado", {});
  };

  handleViewPDF = async () => {
    var ids = {
      ids: [this.obs.item.nota_id],
      filtro: this.props.entrada_saida,
      tipo: this.props.modelo,
      empresa: AppStore.obs1.selectedEmpresa.cnpj,
      data1: moment(this.obs.item.dhemi).format("YYYY-MM-DD"),
      data2: moment(this.obs.item.dhemi).format("YYYY-MM-DD"),
    };

    await ResultadoStore.view_danfe(ids, this.obs.item.chave);
  };

  renderDetailsTab() {
    return (
      <div>

        <div className="item-dialog-chave">
          <span className="detalhamento-field-label">Chave de acesso</span>
          <div className="item-dialog-chave-value">
            <span>{this.obs.item.chave}</span>
            <Button small minimal icon="clipboard" onClick={this.handleCopyChave} />
          </div>
        </div>

        <div className="item-dialog-grid">
          <div className="detalhamento-field">
            <span className="detalhamento-field-label">Série / Número</span>
            <span className="detalhamento-field-value">
              {this.obs.item.serie}/{this.obs.item.numero}
            </span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">Data</span>
            <span className="detalhamento-field-value">
              {moment(this.obs.item.data).format("DD/MM/YYYY")} {moment(this.obs.item.data).format("HH:mm")}
            </span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">CFOP</span>
            <span className="detalhamento-field-value" style={{ fontWeight: 700 }}>
              {this.obs.item.cfop}
            </span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">CST</span>
            <span className="detalhamento-field-value">{this.obs.item.cst}</span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">Valor</span>
            <span className="detalhamento-field-value">
              R$ {numeral(this.obs.item.valor).format("0,0.00")}
            </span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">Data da inserção</span>
            <span className="detalhamento-field-value">
              {moment(this.obs.item.inserted_at).format("L LT")}
            </span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">Data da atualização</span>
            <span className="detalhamento-field-value">
              {moment(this.obs.item._modifiedTS).format("L LT")}
            </span>
          </div>

        </div>

        <div className="item-dialog-chave">
          <span className="detalhamento-field-label">Cálculo</span>
          <div className="item-dialog-chave-value">
            <span>{this.obs.item.calc}</span>
          </div>
        </div>

        {this.obs.item?.contestacao_id && (
          <div className="item-dialog-chave">
            <span className="detalhamento-field-label">ID Contestação</span>
            <div className="item-dialog-chave-value">
              <span>{this.obs.item?.contestacao_id}</span>
              <Button small minimal icon="clipboard" onClick={this.handleCopyId} />
            </div>
          </div>
        )}

        {/* Botões */}
        <div className="item-dialog-actions">
          <MDBBtn
            className="btnDefault btnExportResultados"
            onClick={() => this.handleViewXML(this.obs.item.chave, this.props.entrada_saida, this.props.modelo, this.obs.dhemi)}
          >Download XML</MDBBtn>
          <MDBBtn
            className="btnDefault btnExportResultados"
            onClick={() => this.handleViewPDF()}
          >Download PDF</MDBBtn>
        </div>
      </div>
    );
  }

  renderMemoriaCalc(memoria_calculo: string) {
    let calcName = this.obs.item.calc ? this.obs.item.calc : "Nenhum";

    return (
      <ItemMemoria
        memoria_calculo={memoria_calculo}
        calcName={calcName}
        calc_vars={ResultadoStore.obs.calc_vars}
        nota_vars={ResultadoStore.obs.nota_vars}
        descritivo={ResultadoStore.obs.descritivo_calc}
      />
    );
  }

  renderAlert() {
    return (
      <>
        <div style={{ marginBottom: 10 }}>
          <b>Alerta:</b> {this.obs.item.ie}
        </div>
      </>
    );
  }

  renderData() {
    return (
      <Tabs id="tabs" className="tabsCalculos tabsDetail">
        <Tab id="details" title="Detalhes" panel={this.renderDetailsTab()} />
        {this.obs.item.memoria_calculo ?
          <Tab
            id="calc"
            title="Memória de cálculo"
            panel={this.renderMemoriaCalc(this.obs.item.memoria_calculo)}
          />
          : <></>}
        {this.obs.item.memoria_calculo_1139 ?
          <Tab
            id="calc_1139"
            title="Memória de cálculo 1139"
            panel={this.renderMemoriaCalc(this.obs.item.memoria_calculo_1139)}
          />
          : <></>}
        {this.obs.item.ie && (
          <Tab id="alert" title="Alerta de Cálculo" panel={this.renderAlert()}>
            <span className="badge-emp pulse badge-tab"></span>
          </Tab>
        )}
      </Tabs>
    );
  }

  render() {
    let title = "Detalhes";
    if (this.obs.item) {
      title = `Detalhes: item ${this.obs.item.numero}`;
    }

    return (
      <Dialog
        isOpen={true}
        title={title}
        onClose={this.props.onClose}
        className="detail-item"
      >
        <div className={Classes.DIALOG_BODY}>
          {(this.obs.item && this.renderData()) || this.renderNoData()}
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Fechar" onClick={this.props.onClose} />
          </div>
        </div>
      </Dialog>
    );
  }
}
